import React, { useState } from 'react'

import ModalContabilidade from './ModalContabilidade'
import { api, ListarInformacoesModalContabilidade } from '../../../../services/api'
import { cnpjMask } from '../../../../utils/cnpjMask'
import Moment from 'moment'

import { Table, Thead, Tbody, Tr, Th, Td, useDisclosure, TableContainer, Grid, Flex, useMediaQuery, Tag, Text, Checkbox, Button, useToast } from '@chakra-ui/react'
import { useMutation } from 'react-query'

async function onDelete(selectedToDelete) {
    const response = await api.put('https://api.innovationbrindes.com.br/api/contabilidade/deletar', selectedToDelete)

    return response.data
}

const TabelaContabilidade = ({ dados, noteView, loading }) => {
    const [dadosModal, setDadosModal] = useState([])
    const [numeroNota, setNumeroNota] = useState('')
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [dadosContabilidade, setDadosContabilidade] = useState([])
    const [idRemessa, setIdRemessa] = useState([])
    const [selectedToDelete, setSelectedToDelete] = useState([])

    const toast = useToast({
        position: 'top-right',
        title: 'Sucesso',
        description: 'Nota deletada com sucesso',
    })

    const [isLargerThan1366] = useMediaQuery('(min-width: 1366px)')

    const ListarInfoModalContabilidade = async (numeroNota) => {
        try {
            const { data } = await ListarInformacoesModalContabilidade.get('/' + numeroNota)
            console.log('data', data)
            setDadosModal(data)
        } catch (error) {
            console.log(Object.keys(error), error.message)
        }
    }

    const counterNumPed = dados.filter((item, index, self) => self.findIndex((t) => t.numero_pedido === item.numero_pedido) === index).length

    function handleSelectToDelete({ numero_pedido, numero_nota }) {
        const isSelected = selectedToDelete.some((item) => item.numero_nota === numero_nota && item.numero_pedido === numero_pedido)
        if (isSelected) {
            setSelectedToDelete(selectedToDelete.filter((item) => item.numero_nota !== numero_nota))
        } else {
            setSelectedToDelete([...selectedToDelete, { numero_pedido, numero_nota }])
        }
    }

    const { mutateAsync, isLoading } = useMutation({
        mutationFn: onDelete,
        onSuccess: () => {
            toast({
                status: 'success',
                duration: 9000,
                isClosable: true,
            })

            window.location.reload()
        },
        onError: () => {
            toast({
                status: 'error',
                duration: 9000,
                isClosable: true,
            })
        },
    })

    async function handleDeleteSelected() {
        await mutateAsync(selectedToDelete)
    }

    return (
        <>
            <Text fontSize="1.2rem" fontWeight="bold" color="#606163" marginLeft={'1rem'}>
                {counterNumPed} Pedidos
            </Text>
            <Button colorScheme="red" size="sm" borderRadius={0} m={2} onClick={handleDeleteSelected} isLoading={isLoading} loadingText="Deletando">
                {selectedToDelete?.length} Selecionados - Excluir
            </Button>

            <Flex width="100%" justifyContent="center" marginTop="1.6rem">
                <TableContainer maxH={isLargerThan1366 ? 'calc(100vh - 25rem)' : 'calc(100vh - 20rem)'} scrollY="auto" overflowY="scroll">
                    <Grid templateColumns="600px .9fr 1.1fr" gap={3}>
                        <Table variant="simple" scrollY="auto" overflow="scroll">
                            <Thead bgColor="#606163">
                                <Tr>
                                    <Th />
                                    <Th color="white">Pedido</Th>
                                    <Th color="white">Data solicitação</Th>
                                    <Th color="white">Data resposta</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {dados.map((data, idx) => {
                                    return (
                                        <Tr key={idx} _hover={{ bgColor: '#dfdfdf' }} _even={{ bgColor: '#dfdfdf' }}>
                                            <Td>
                                                <Checkbox
                                                    colorScheme="green"
                                                    size="lg"
                                                    onChange={(e) => {
                                                        handleSelectToDelete({
                                                            numero_pedido: data.numero_pedido,
                                                            numero_nota: data.numero_nota,
                                                        })
                                                    }}
                                                    isChecked={selectedToDelete.some((item) => item.numero_nota === data.numero_nota && item.numero_pedido === data.numero_pedido)}
                                                />
                                            </Td>

                                            <Td
                                                onClick={() => {
                                                    if (data.inscricao_est !== 'ISENTO') {
                                                        onOpen()
                                                        ListarInfoModalContabilidade(data.numero_nota)
                                                        setNumeroNota(data.numero_nota)
                                                        setDadosContabilidade(data)
                                                        setIdRemessa(data.cnpj_2)
                                                    }
                                                }}
                                                cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'}
                                            >
                                                {data.numero_pedido}
                                            </Td>
                                            <Td
                                                onClick={() => {
                                                    if (data.inscricao_est !== 'ISENTO') {
                                                        onOpen()
                                                        ListarInfoModalContabilidade(data.numero_nota)
                                                        setNumeroNota(data.numero_nota)
                                                        setDadosContabilidade(data)
                                                        setIdRemessa(data.cnpj_2)
                                                    }
                                                }}
                                                cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'}
                                            >
                                                {Moment(data.data_solicitacao).format('DD/MM/YYYY' + ' ' + 'HH:mm') !== 'Invalid date' ? (
                                                    Moment(data.data_solicitacao).format('DD/MM/YYYY' + ' ' + 'HH:mm')
                                                ) : (
                                                    <Tag size="md" variant="solid">
                                                        Sem data
                                                    </Tag>
                                                )}
                                            </Td>
                                            <Td
                                                onClick={() => {
                                                    if (data.inscricao_est !== 'ISENTO') {
                                                        onOpen()
                                                        ListarInfoModalContabilidade(data.numero_nota)
                                                        setNumeroNota(data.numero_nota)
                                                        setDadosContabilidade(data)
                                                        setIdRemessa(data.cnpj_2)
                                                    }
                                                }}
                                                cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'}
                                            >
                                                {Moment(data.data).format('DD/MM/YYYY' + ' ' + 'HH:mm') !== 'Invalid date' ? (
                                                    Moment(data.data).format('DD/MM/YYYY' + ' ' + 'HH:mm')
                                                ) : (
                                                    <Tag size="md" variant="solid">
                                                        Sem data
                                                    </Tag>
                                                )}
                                            </Td>
                                        </Tr>
                                    )
                                })}
                            </Tbody>
                        </Table>
                        <Table variant="simple" maxW="100px">
                            <Thead bgColor="#5292a2">
                                <Tr _even={{ bgColor: '#dfdfdf' }}>
                                    <Th color="white">Faturamento</Th>
                                    <Th color="white">CNPJ</Th>
                                    <Th color="white">Insc. Estadual</Th>
                                    <Th color="white">Estado</Th>
                                    <Th color="white">Tipo Uso</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {dados.map((data, idx) => {
                                    return (
                                        <Tr
                                            key={idx}
                                            _hover={{ bgColor: '#dfdfdf' }}
                                            _even={{ bgColor: '#dfdfdf' }}
                                            onClick={() => {
                                                if (data.inscricao_est !== 'ISENTO') {
                                                    onOpen()
                                                    ListarInfoModalContabilidade(data.numero_nota)
                                                    setNumeroNota(data.numero_nota)
                                                    setDadosContabilidade(data)
                                                    setIdRemessa(data.cnpj_2)
                                                }
                                            }}
                                        >
                                            <Td cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'}>{data.faturamento.slice(0, 10) + '...'}</Td>
                                            <Td cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'}>{cnpjMask(data.cnpj)}</Td>
                                            <Td cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'}>{data.inscricao_est}</Td>
                                            <Td cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'} textAlign="center">
                                                {data.estado}
                                            </Td>
                                            <Td cursor={data.inscricao_est === 'ISENTO' ? 'not-allowed' : 'pointer'}>{data.tipo_uso}</Td>
                                        </Tr>
                                    )
                                })}
                            </Tbody>
                        </Table>
                        <Table variant="simple" maxW="100px">
                            <Thead bgColor="#3a7993">
                                <Tr>
                                    <Th color="white">Entrega</Th>
                                    <Th color="white">CNPJ</Th>
                                    <Th color="white">Insc. Estadual</Th>
                                    <Th color="white">Estado</Th>
                                    <Th color="white">Qtde. Itens</Th>
                                    <Th color="white" textAlign="center">
                                        Status
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {dados.map((data, idx) => {
                                    return (
                                        <Tr
                                            key={idx}
                                            _hover={{ bgColor: '#dfdfdf' }}
                                            _even={{ bgColor: '#dfdfdf' }}
                                            onClick={() => {
                                                if (data.inscricao_est_2 !== 'ISENTO') {
                                                    onOpen()
                                                    ListarInfoModalContabilidade(data.numero_nota)
                                                    setNumeroNota(data.numero_nota)
                                                    setDadosContabilidade(data)
                                                    setIdRemessa(data.cnpj_2)
                                                }
                                            }}
                                        >
                                            <Td cursor={data.inscricao_est_2 === 'ISENTO' ? 'not-allowed' : 'pointer'}>{data.faturamento_2.slice(0, 10) + '...'}</Td>
                                            <Td cursor={data.inscricao_est_2 === 'ISENTO' ? 'not-allowed' : 'pointer'}>{cnpjMask(data.cnpj_2)}</Td>
                                            <Td cursor={data.inscricao_est_2 === 'ISENTO' ? 'not-allowed' : 'pointer'}>{data.inscricao_est_2}</Td>
                                            <Td cursor={data.inscricao_est_2 === 'ISENTO' ? 'not-allowed' : 'pointer'} textAlign="center">
                                                {data.cnpj === data.cnpj_2 ? data.estado : data.estado_2}
                                            </Td>
                                            <Td cursor={data.inscricao_est_2 === 'ISENTO' ? 'not-allowed' : 'pointer'} textAlign="center">
                                                {data.qtd_itens}
                                            </Td>
                                            <Td textAlign="center">
                                                {data.pendente === '3' ? (
                                                    <Tag bgColor="#d4af37" color="#333">
                                                        Pendente
                                                    </Tag>
                                                ) : (
                                                    <Tag colorScheme="green">Concluído</Tag>
                                                )}
                                            </Td>
                                        </Tr>
                                    )
                                })}
                            </Tbody>
                        </Table>
                    </Grid>
                </TableContainer>
            </Flex>
            <ModalContabilidade dadosModal={dadosModal} numeroNota={numeroNota} onClose={onClose} onOpen={onOpen} isOpen={isOpen} dadosContabilidade={dadosContabilidade} idRemessa={idRemessa} />
        </>
    )
}

export default TabelaContabilidade
